import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import axios from "axios";

import Navbar from "./components/Navbar";
import About from "./pages/About";
import Work from "./pages/Work";
import Skill from "./pages/Skill";
import Footer from "./components/Footer";
import "./App.css";
import "./responsive.css";
import Contact from "./pages/Contact";
import WorkDetail from "./pages/WorkDetail";
import LoadingScreen from "./pages/LoadingScreen";
const URL = process.env.REACT_APP_API_URL;

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);

  return (
    <>
      <main className="app">
        <Navbar />
        <Routes>
          <Route path="/" element={<About />} />
          <Route path="/projects" element={<Work />} />
          <Route path="/work-detail/:slug" element={<WorkDetail />} />
          <Route path="/skill" element={<Skill />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default App;
